/* ============================================================
   PAMÉ pager — right-edge vertical dashes, one per full-screen
   home section. Active dash turns gold and grows longer.
   Click a dash to glide to that section.
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var pager = document.querySelector('.pame-pager');
    var main = document.getElementById('MainContent');
    if (!pager || !main) return;

    // Full-screen sections only (skips the hidden opening overlay wrapper).
    var sections = Array.prototype.slice.call(main.children).filter(function (el) {
      return el.classList.contains('shopify-section') && el.offsetHeight > 200;
    });
    if (sections.length < 2) return;

    pager.innerHTML = '';
    sections.forEach(function (sec, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'pame-pager__dot';
      dot.setAttribute('aria-label', 'セクション ' + (i + 1) + 'へ移動');
      dot.addEventListener('click', function () {
        sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      pager.appendChild(dot);
    });

    var dots = pager.querySelectorAll('.pame-pager__dot');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var idx = sections.indexOf(entry.target);
        if (idx < 0) return;
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === idx); });
      });
    }, { threshold: 0.55 });

    sections.forEach(function (s) { observer.observe(s); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
